import React, { useState, useEffect, useRef } from 'react';

const CustomSelect = ({ options, value, onChange }) => {
    const [isOpen, setIsOpen] = useState(false);
    const [selectedValue, setSelectedValue] = useState(value);
    const ref = useRef();

    useEffect(() => {
        const handleClickOutside = (event) => {
            if (ref.current && !ref.current.contains(event.target)) {
                setIsOpen(false);
            }
        };
        document.addEventListener('click', handleClickOutside);
        return () => {
            document.removeEventListener('click', handleClickOutside);
        };
    }, []);

    const handleOptionClick = (option) => {
        setSelectedValue(option.key);
        onChange(option.key, option.resourceId, option.value);
        setIsOpen(false);
    };

    return (
        <div className="custom-select-wrapper" ref={ref} >
            <select
                className="hidden-select"
                value={selectedValue}
                onChange={(e) => handleOptionClick(options.find(opt => opt.key === e.target.value))}
            >
                {options.map((option) => (
                    <option key={option.key} value={option.key}>
                        {option.value}
                    </option>
                ))}
            </select>
            <div className="custom-select arrow-down_icon-wrapper" onClick={() => setIsOpen(!isOpen)}>
                <div className="custom-select-trigger">{options.find(opt => opt.key === selectedValue)?.value || 'Velg optiker'}</div>
                {isOpen && (
                    <div className="custom-options">
                        {options.map((option) => (
                            <span
                                key={option.key}
                                className={option.value === "" ? "custom-option-large" : "custom-option"}
                                onClick={() => handleOptionClick(option)}
                            >
                                {option.value}
                            </span>
                        ))}
                    </div>
                )}
                <div className="arrow-down_icon" />
            </div>            
        </div>
    );
};

export default CustomSelect;
